export default __webpack_public_path__ + "static/media/night_half_moon_partial_cloud.bdc28627.svg";